import { render } from "./MainBlock.vue?vue&type=template&id=6fe1ff48"
import script from "./MainBlock.vue?vue&type=script&lang=js"
export * from "./MainBlock.vue?vue&type=script&lang=js"

import "./MainBlock.vue?vue&type=style&index=0&id=6fe1ff48&lang=scss"
script.render = render

export default script